module.exports = __webpack_public_path__ + "static/media/CHAP00-OUVERTURE.5fd1d5ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP00-OUVERTURE.png
// module id = 266
// module chunks = 0